import React from 'react';

export const ReportIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-report"
      style={props.style || { color: '#757575', transform: 'scale(0.7)' }}
    />
  );
};
